export const Marquee = ({ items, className = "" }) => {
  const seq = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-white/10 py-6 md:py-8 select-none ${className}`} data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform items-center">
        {seq.map((item, i) => {
          const isObj = typeof item === "object" && item !== null;
          const logo = isObj ? item.logo : null;
          const label = isObj ? item.name : item;
          return (
            <span key={i} className="mx-3 md:mx-4 inline-flex items-center">
              {logo ? (
                <span className="inline-flex items-center justify-center bg-white rounded-lg px-5 md:px-7 h-28 md:h-40 shadow-lg">
                  <img src={logo} alt={label || "Brand logo"} decoding="async" className="max-h-[84%] max-w-[260px] md:max-w-[360px] w-auto object-contain" />
                </span>
              ) : (
                <span className="font-display text-6xl md:text-8xl leading-none uppercase text-stroke-gold">{label}</span>
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
};
